export default __webpack_public_path__ + "static/media/Marketing@32.f33179a7.svg";